<script setup lang="ts">
import SvgIcon from "../Common/SvgIcon.vue";

defineProps({
  withShadow: {
    type: Boolean,
    default: true,
  },
  back: {
    type: Boolean,
    default: false,
  },
  backIcon: {
    type: String,
    default: "arrow_left",
  },
  close: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["close", "backClick"]);
</script>

<template>
  <div :class="`${withShadow ? 'header_details__container' : 'header_details_2__container'}`">
    <!-- Left -->
    <div class="header_details__back_button_container" @click="emit('backClick')">
      <slot v-if="$slots.back" name="back"></slot>
      <SvgIcon v-else-if="back && !$slots.back" :name="backIcon" class="header_details__back_button" />
    </div>

    <!-- Center -->
    <div class="justify-self-center">
      <slot name="page"></slot>
    </div>

    <!-- Right -->
    <div class="flex items-center gap-4 justify-self-end pr-4">
      <slot name="actions"></slot>
      <img
        v-if="close"
        class="header_details__close_button"
        src="/icons/generic/close.svg"
        alt=""
        @click="emit('close')"
      />
    </div>
  </div>
  <div v-if="!withShadow" class="header__loading_bar"></div>
</template>

<style scoped lang="scss">
.header_details__container {
  @apply grid items-center;
  grid-template-columns: 1fr auto 1fr;
  height: var(--header_details_height);
  color: var(--text-tertiary-color);
  background: var(--white-main);
  box-shadow: var(--shadow-medium);
  min-height: var(--header_details_height);
}

.header_details_2__container {
  @apply grid items-center;
  grid-template-columns: 1fr auto 1fr;
  height: var(--header_details_height);
  color: var(--text-tertiary-color);
  min-height: var(--header_details_height);
}

.header__loading_bar {
  width: 100%;
  height: 2px;
  background: var(--grey-light);
}

.header_details__back_button {
  @apply cursor-pointer rounded-2xl max-h-[24px] max-w-[24px] h-full w-full text-secondary-color;

  &:hover {
    background: var(--grey-light);
    color: var(--text-main-color);
  }
}

.header_details__close_button {
  @apply p-[8px] cursor-pointer rounded-2xl;

  &:hover {
    background: var(--grey-light);
  }
}

.header_details__back_button_container {
  @apply flex items-center gap-2 justify-self-start ml-4 cursor-pointer text-secondary-color;

  &:hover {
    color: var(--text-main-color);
  }
}
</style>
